import React from "react";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "react-responsive";
import MobileFeatureView from "./MobileFeatureView";
import TabletFeatureView from "./TabletFeatureView";
import DesktopFeatureView from "./DesktopFeatureView";
import "./Feature.css";
import abbRobot from "../../assets/abb-robot.jpeg";
import pnc from "../../assets/pnc.jpeg";
import operator from "../../assets/operator.jpeg";

const Feature = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const featureIcons = [
    "mdi:account-cash-outline",
    "mdi:cog-sync",
    "mdi:chart-line",
    "mdi:check-decagram",
  ];

  const featureTexts = [
    "Low initial investment, ROI within 2 years.",
    "Easy setup, operator-friendly interface, no expert required.",
    "3x productivity, reduce wastage, improve quality.",
    "Centralized data for better decision-making.",
  ];

  const images = {
    abbRobot,
    pnc,
    operator,
  };

  // Common props to pass to all view components
  const commonProps = {
    inView,
    fadeInUp,
    featureIcons,
    featureTexts,
    images,
  };

  return (
    <div ref={ref}>
      {isMobile && <MobileFeatureView {...commonProps} />}
      {isTablet && <TabletFeatureView {...commonProps} />}
      {!isMobile && !isTablet && <DesktopFeatureView {...commonProps} />}
    </div>
  );
};

export default Feature;
